/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ig-calendar{height:100%;position:relative;background-color:#eef5f9;width:100%}.ig-calendar .container-box{width:100%}.ig-calendar ig-page-spinner .mask{width:calc(100% - 4rem);background-color:#eef5f9}.no-more-data{text-align:center;font-size:24px;color:gray}.modern-block-item:first-child{grid-column-start:1;grid-column-end:3}.modern-block-item:first-child .modern-block-time .day{font-size:1.8em}.modern-block-item:first-child .modern-block-time .month{font-size:1.2em}@media (max-width:1080px){.ig-calendar{padding-right:.5rem}.ig-calendar .water-fall-container{padding-top:58px;height:calc(100% - 58px)!important}.ig-calendar ig-page-spinner .mask{width:100%}}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/calendar/visitor.calendar.component.scss.ngstyle.js.pre-build-optimizer.js